// extracted by mini-css-extract-plugin
export default {"tx":"c378b37205","line":"_208fab983c"};